import type { AgrupamentoCarga } from "@/modules/recursos";
import type { GanttIndicadores } from "@/shared/components/gantt-carga/gantt-carga.constants";

import type { CargaEstadoIds } from "./components/carga-estado";
import type { CargaToolbarIds } from "./components/carga-toolbar";

/** O que a busca de cada visão casa: o item da visão e, nas alocações, o código da obra e o acrônimo da embarcação. */
export const CARGA_PROFISSIONAIS_SEARCH_PLACEHOLDER = "Buscar nome, obra...";
export const CARGA_LOCAL_SEARCH_PLACEHOLDER = "Buscar local, obra...";
export const CARGA_FORNECEDOR_SEARCH_PLACEHOLDER = "Buscar fornecedor...";

/** Perspectivas do Gantt: Profissionais (US-1779), Fornecedor (US-1774) e Local (US-2023). */
export type CargaPerspectiva = "profissionais" | "fornecedor" | "local";

export const PERSPECTIVA_OPTIONS: { label: string; value: CargaPerspectiva }[] = [
  { label: "Profissionais", value: "profissionais" },
  { label: "Fornecedores", value: "fornecedor" },
  { label: "Locais", value: "local" },
];

export const DEFAULT_PERSPECTIVA: CargaPerspectiva = "profissionais";

/** "Visualizar por" (a HU chama de "Agrupar por"). */
export const AGRUPAMENTO_OPTIONS: { label: string; value: AgrupamentoCarga }[] = [
  { label: "Fornecedor", value: "fornecedor" },
  { label: "Obras", value: "obra" },
];

export const DEFAULT_AGRUPAMENTO: AgrupamentoCarga = "fornecedor";

/** "Visualizar por" na perspectiva Local (US-2023). */
export type AgrupamentoLocal = "local" | "obra";

export const AGRUPAMENTO_LOCAL_OPTIONS: { label: string; value: AgrupamentoLocal }[] = [
  { label: "Local", value: "local" },
  { label: "Obra", value: "obra" },
];

export const DEFAULT_AGRUPAMENTO_LOCAL: AgrupamentoLocal = "local";

/** Local e Fornecedor: Cancelada fica oculta por padrão (RN13 da 1779), como em Profissionais. */
export const DEFAULT_INDICADORES: GanttIndicadores = { obra: true, cancelada: false };

/** Indicadores do modal de Local e Fornecedor. */
export const INDICADORES_OBRA_E_CANCELADA = [
  { key: "obra", label: "Obra" },
  { key: "cancelada", label: "Cancelada" },
] as const;

export const FILTROS_EM_BREVE = "Em breve";

/** Ids de teste da barra, dos estados, dos chips e da legenda das perspectivas Profissionais e Local. */
export const CARGA_TOOLBAR_IDS: CargaToolbarIds = {
  toolbar: "carga-de-trabalho-toolbar",
  search: "carga-de-trabalho-search",
  periodo: "carga-de-trabalho-period",
  agrupamento: "carga-de-trabalho-grouping",
  agrupamentoHint: "carga-de-trabalho-grouping-hint",
  filtros: "carga-de-trabalho-filters",
  perspectivas: "carga-de-trabalho-perspectives",
  perspectivaPrefixo: "carga-de-trabalho-perspective",
  menu: "carga-de-trabalho-menu",
  menuPapeis: "carga-de-trabalho-papeis",
  menuExportar: "carga-de-trabalho-export-view",
  menuIndicadores: "carga-de-trabalho-indicators-toggle",
};

export const CARGA_ESTADO_IDS: CargaEstadoIds = {
  forbidden: "carga-de-trabalho-forbidden",
  loading: "carga-de-trabalho-loading",
  error: "carga-de-trabalho-error",
  retry: "carga-de-trabalho-retry",
  empty: "carga-de-trabalho-empty",
};

export const CARGA_CHIP_TEST_ID_PREFIX = "carga-de-trabalho-chip";
export const CARGA_LEGEND_TEST_ID = "carga-de-trabalho-legend";

/** Escopo dos filtros salvos de cada perspectiva (separados entre si e das demais telas). */
export const CARGA_PROFISSIONAIS_SAVED_FILTERS_SCREEN = "carga-profissionais";
export const CARGA_FORNECEDOR_SAVED_FILTERS_SCREEN = "carga-fornecedor";
export const CARGA_LOCAL_SAVED_FILTERS_SCREEN = "carga-local";
